import { render, staticRenderFns } from "./AlertSection.vue?vue&type=template&id=bb013292&scoped=true&"
import script from "./AlertSection.vue?vue&type=script&lang=ts&"
export * from "./AlertSection.vue?vue&type=script&lang=ts&"
import style0 from "./AlertSection.vue?vue&type=style&index=0&id=bb013292&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb013292",
  null
  
)

export default component.exports